export enum LoginStatus {
  Idle,
  Success,
  Expired,
}
